import React, { useState } from 'react';
import { dySPA } from 'core/utils/analytics/dyAnalytics';
import ButtonSort from './components/ButtonSort/ButtonSort';
import DropdownSort from './components/DropdownSort/DropdownSort';

import './Sort.scss';

function Sort({
  sortOptions, sortType, selectedOption, sortLabel, fetchPlacementsMethod,
}) {
  const [sortOptionsState, setSortOptionsState] = useState(sortOptions);

  const getSelectedSortedOption = (selectedSortBy) => (
    sortOptionsState.find(sortOption => sortOption.sortBy === selectedSortBy)
  );

  const updateSortState = (selectedSortBy) => {
    sortOptionsState.forEach((sortOption) => {
      // eslint-disable-next-line no-param-reassign
      sortOption.className = sortOption.sortBy === selectedSortBy ? 'mn_selected' : '';

      if (sortOption.sortBy === selectedSortBy) {
        // eslint-disable-next-line no-param-reassign
        sortOption.sortType = sortOption.sortType === 'asc' ? 'desc' : 'asc';
      }

      return sortOption;
    });

    setSortOptionsState(sortOptionsState);
  };

  const handleSortButtonClick = (e, selectedSortBy) => {
    const selectedSortOption = getSelectedSortedOption(selectedSortBy);
    const { sortBy, sortType } = selectedSortOption;

    fetchPlacementsMethod({
      sort_by: sortBy,
      sort_type: sortType,
      pageNumber: 1,
    });

    updateSortState(selectedSortBy);
    dySPA.sendEvent();
  };

  return (
    <div>
      <div className="mn_dataTableSort" data-test="sort">
        {
          sortType === 'dropdown' ?
            <DropdownSort
              sortOptions={sortOptionsState}
              sortingHandler={handleSortButtonClick}
              selectedOption={selectedOption}
              sortLabel={sortLabel}
            /> :
            <ButtonSort sortOptions={sortOptionsState} sortingHandler={handleSortButtonClick} />
        }
      </div>
    </div>
  );
}

export default Sort;
